const mapOptions = {
  minZoom: 3,
  maxZoom: 18,
  fullscreenControl: false,
  gestureHandling: 'greedy',
};

export default mapOptions;
